/* In-memory mocked client for Cash Transactions — no real backend exists for this domain yet. */

import {
  CashEventDto,
  CashEventType,
  CashReconciliationDto,
  TillStateDto,
  ExpectedCashCalculationDto,
  CashZoneDto,
  CreateCashEventRequest,
  OpenTillRequest,
  CloseTillRequest,
  ApproveCashReconciliationRequest,
  CreateCashDropRequest,
  ReverseCashEventRequest,
} from './cashTransactionTypes';
import { ICashTransactionClient } from './ICashTransactionClient';

let nextEventId = 100;
let nextZoneId = 100;
let nextReconciliationId = 100;

const mockZones: CashZoneDto[] = [
  { id: 1, storeNumber: 'STORE001', zoneName: 'Till 1', zoneType: 'Till', isActive: true, requiresTwoPersonApproval: false, varianceThresholdAmount: 10, rowNumber: 1 },
  { id: 2, storeNumber: 'STORE001', zoneName: 'Till 2', zoneType: 'Till', isActive: true, requiresTwoPersonApproval: false, varianceThresholdAmount: 10, rowNumber: 2 },
  { id: 3, storeNumber: 'STORE001', zoneName: 'Safe', zoneType: 'Safe', isActive: true, requiresTwoPersonApproval: true, varianceThresholdAmount: 50, rowNumber: 3 },
  { id: 4, storeNumber: 'STORE001', zoneName: 'Back Office', zoneType: 'BackOffice', isActive: true, requiresTwoPersonApproval: false, varianceThresholdAmount: 20, rowNumber: 4 },
  { id: 5, storeNumber: 'STORE001', zoneName: 'Till 3', zoneType: 'Till', isActive: false, requiresTwoPersonApproval: false, varianceThresholdAmount: 10, rowNumber: 5 },
  { id: 6, storeNumber: 'STORE001', zoneName: 'Banking Desk', zoneType: 'Banking', isActive: true, requiresTwoPersonApproval: true, varianceThresholdAmount: 100, rowNumber: 6 },
];

const mockTillStates: TillStateDto[] = [
  { storeNumber: 'STORE001', tillNumber: 'TILL-01', zoneId: 1, status: 'Open', currentBalance: 250.0, currentShiftId: 'shift-1', assignedUserId: 'user-1', assignedUsername: 'John Smith', isLocked: false },
  { storeNumber: 'STORE001', tillNumber: 'TILL-02', zoneId: 2, status: 'Closed', currentBalance: 0, isLocked: false },
  { storeNumber: 'STORE001', tillNumber: 'TILL-03', zoneId: 5, status: 'Closed', currentBalance: 0, isLocked: true },
];

const mockEvents: CashEventDto[] = [
  { id: 1, eventType: 'TillOpen', storeNumber: 'STORE001', tillNumber: 'TILL-01', zoneId: 1, amount: 200.0, currencyCode: 'GBP', userId: 'user-1', username: 'John Smith', timestamp: new Date(Date.now() - 28800000).toISOString(), referenceId: 'OPEN-001', isReversed: false, metadata: {}, createdAtUtc: new Date(Date.now() - 28800000).toISOString() },
  { id: 2, eventType: 'Sale', storeNumber: 'STORE001', tillNumber: 'TILL-01', zoneId: 1, amount: 45.5, currencyCode: 'GBP', userId: 'user-1', username: 'John Smith', timestamp: new Date(Date.now() - 25200000).toISOString(), referenceId: 'SALE-001', isReversed: false, metadata: {}, createdAtUtc: new Date(Date.now() - 25200000).toISOString() },
  { id: 3, eventType: 'Sale', storeNumber: 'STORE001', tillNumber: 'TILL-01', zoneId: 1, amount: 12.8, currencyCode: 'GBP', userId: 'user-1', username: 'John Smith', timestamp: new Date(Date.now() - 21600000).toISOString(), referenceId: 'SALE-002', isReversed: false, metadata: {}, createdAtUtc: new Date(Date.now() - 21600000).toISOString() },
  { id: 4, eventType: 'CashDrop', storeNumber: 'STORE001', tillNumber: 'TILL-01', zoneId: 1, amount: -100.0, currencyCode: 'GBP', userId: 'user-2', username: 'Jane Doe', timestamp: new Date(Date.now() - 18000000).toISOString(), referenceId: 'DROP-001', isReversed: false, metadata: {}, createdAtUtc: new Date(Date.now() - 18000000).toISOString() },
];

const mockReconciliations: CashReconciliationDto[] = [
  {
    id: 1, storeNumber: 'STORE001', tillNumber: 'TILL-01', zoneId: 1, reconciliationDate: new Date(Date.now() - 86400000).toISOString(), status: 'Reconciled',
    openingBalance: 200, openingTimestamp: new Date(Date.now() - 172800000).toISOString(), openedByUserId: 'user-1', openedByUsername: 'John Smith',
    expectedCashSales: 158.3, expectedTotalSales: 258.3, expectedCardSales: 100, expectedRefunds: 0, expectedPaidIns: 0, expectedPaidOuts: 0, expectedCashDrops: -100, expectedClosingBalance: 258.3,
    declaredClosingBalance: 255.0, declaredTimestamp: new Date(Date.now() - 86400000).toISOString(), declaredByUserId: 'user-1', declaredByUsername: 'John Smith',
    countMethod: 'QuickTotal', variance: -3.3, variancePercentage: -1.28, isOverThreshold: false, requiresApproval: false,
    createdAtUtc: new Date(Date.now() - 86400000).toISOString(), updatedAtUtc: new Date(Date.now() - 86400000).toISOString(),
  },
  {
    id: 2, storeNumber: 'STORE001', tillNumber: 'TILL-02', zoneId: 2, reconciliationDate: new Date(Date.now() - 86400000).toISOString(), status: 'Reconciled',
    openingBalance: 200, openingTimestamp: new Date(Date.now() - 172800000).toISOString(), openedByUserId: 'user-2', openedByUsername: 'Jane Doe',
    expectedCashSales: 210, expectedTotalSales: 410, expectedCardSales: 200, expectedRefunds: 0, expectedPaidIns: 0, expectedPaidOuts: 0, expectedCashDrops: 0, expectedClosingBalance: 410,
    declaredClosingBalance: 410, declaredTimestamp: new Date(Date.now() - 86400000).toISOString(), declaredByUserId: 'user-2', declaredByUsername: 'Jane Doe',
    countMethod: 'QuickTotal', variance: 0, variancePercentage: 0, isOverThreshold: false, requiresApproval: false,
    createdAtUtc: new Date(Date.now() - 86400000).toISOString(), updatedAtUtc: new Date(Date.now() - 86400000).toISOString(),
  },
];

export class CashTransactionClientMocked implements ICashTransactionClient {
  // Cash Events
  async getCashEvents(storeNumber: string, startDate: string, endDate: string, tillNumber?: string): Promise<CashEventDto[]> {
    // Demo data ignores store scoping entirely - return events regardless of store.
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    return mockEvents.filter((e) => {
      const t = new Date(e.timestamp).getTime();
      const matchesTill = !tillNumber || e.tillNumber === tillNumber;
      return matchesTill && t >= start && t <= end;
    });
  }

  async getCashEventById(eventId: number): Promise<CashEventDto> {
    const event = mockEvents.find((e) => e.id === eventId);
    if (!event) throw new Error(`Cash event ${eventId} not found`);
    return event;
  }

  async createCashEvent(event: CreateCashEventRequest): Promise<CashEventDto> {
    const timestamp = new Date().toISOString();
    const created: CashEventDto = {
      id: ++nextEventId,
      eventType: event.eventType,
      storeNumber: event.storeNumber,
      tillNumber: event.tillNumber,
      zoneId: event.zoneId,
      amount: event.amount,
      currencyCode: 'GBP',
      userId: 'user-1',
      username: 'Demo User',
      timestamp,
      shiftId: event.shiftId,
      referenceId: event.referenceId ?? `EVENT-${nextEventId}`,
      isReversed: false,
      notes: event.notes,
      metadata: event.metadata ?? {},
      createdAtUtc: timestamp,
    };
    mockEvents.push(created);
    return created;
  }

  async reverseCashEvent(request: ReverseCashEventRequest): Promise<CashEventDto> {
    const original = mockEvents.find((e) => e.id === request.eventIdToReverse);
    if (!original) throw new Error(`Cash event ${request.eventIdToReverse} not found`);
    original.isReversed = true;
    const timestamp = new Date().toISOString();
    const reversal: CashEventDto = {
      ...original,
      id: ++nextEventId,
      eventType: 'Reconciliation' as CashEventType,
      amount: -original.amount,
      timestamp,
      reversalOfEventId: original.id,
      isReversed: false,
      notes: request.reason,
      createdAtUtc: timestamp,
    };
    mockEvents.push(reversal);
    return reversal;
  }

  // Cash Zones
  async getCashZones(storeNumber: string): Promise<CashZoneDto[]> {
    // Demo data ignores store scoping entirely - return zones regardless of store.
    return mockZones;
  }

  async getCashZoneById(zoneId: number): Promise<CashZoneDto> {
    const zone = mockZones.find((z) => z.id === zoneId);
    if (!zone) throw new Error(`Cash zone ${zoneId} not found`);
    return zone;
  }

  async createCashZone(zone: Omit<CashZoneDto, 'id'>): Promise<CashZoneDto> {
    const created: CashZoneDto = { ...zone, id: ++nextZoneId };
    mockZones.push(created);
    return created;
  }

  async updateCashZone(zoneId: number, zone: Partial<CashZoneDto>): Promise<CashZoneDto> {
    const existing = mockZones.find((z) => z.id === zoneId);
    if (!existing) throw new Error(`Cash zone ${zoneId} not found`);
    Object.assign(existing, zone);
    return existing;
  }

  async deleteCashZone(zoneId: number): Promise<void> {
    const idx = mockZones.findIndex((z) => z.id === zoneId);
    if (idx !== -1) mockZones.splice(idx, 1);
  }

  // Till State
  async getTillState(storeNumber: string, tillNumber: string): Promise<TillStateDto> {
    // Demo data ignores store scoping entirely - match by till number only.
    const state = mockTillStates.find((t) => t.tillNumber === tillNumber);
    if (!state) throw new Error(`Till ${tillNumber} not found for store ${storeNumber}`);
    return state;
  }

  async getAllTillStates(storeNumber: string): Promise<TillStateDto[]> {
    // Demo data ignores store scoping entirely - return till states regardless of store.
    return mockTillStates;
  }

  // Till Lifecycle
  async openTill(request: OpenTillRequest): Promise<CashReconciliationDto> {
    const state = mockTillStates.find((t) => t.tillNumber === request.tillNumber);
    const timestamp = new Date().toISOString();
    if (state) {
      state.status = 'Open';
      state.currentBalance = request.openingBalance;
      state.assignedUsername = 'Demo User';
      state.assignedUserId = 'user-1';
    }
    const created: CashReconciliationDto = {
      id: ++nextReconciliationId,
      storeNumber: request.storeNumber,
      tillNumber: request.tillNumber,
      zoneId: request.zoneId,
      reconciliationDate: timestamp,
      shiftId: request.shiftId,
      status: 'Open',
      openingBalance: request.openingBalance,
      openingTimestamp: timestamp,
      openedByUserId: 'user-1',
      openedByUsername: 'Demo User',
      expectedCashSales: 0,
      expectedTotalSales: 0,
      expectedCardSales: 0,
      expectedRefunds: 0,
      expectedPaidIns: 0,
      expectedPaidOuts: 0,
      expectedCashDrops: 0,
      expectedClosingBalance: request.openingBalance,
      denominationBreakdown: request.denominationBreakdown,
      countMethod: 'QuickTotal',
      variance: 0,
      variancePercentage: 0,
      isOverThreshold: false,
      requiresApproval: false,
      notes: request.notes,
      createdAtUtc: timestamp,
      updatedAtUtc: timestamp,
    };
    mockReconciliations.push(created);
    return created;
  }

  async closeTill(request: CloseTillRequest): Promise<CashReconciliationDto> {
    const reconciliation = mockReconciliations.find((r) => r.id === request.reconciliationId);
    if (!reconciliation) throw new Error(`Reconciliation ${request.reconciliationId} not found`);
    const timestamp = new Date().toISOString();
    reconciliation.status = 'Closed';
    reconciliation.declaredClosingBalance = request.declaredClosingBalance;
    reconciliation.declaredTimestamp = timestamp;
    reconciliation.declaredByUserId = 'user-1';
    reconciliation.declaredByUsername = 'Demo User';
    reconciliation.denominationBreakdown = request.denominationBreakdown;
    reconciliation.countMethod = request.countMethod;
    reconciliation.variance = request.declaredClosingBalance - reconciliation.expectedClosingBalance;
    reconciliation.variancePercentage = reconciliation.expectedClosingBalance
      ? (reconciliation.variance / reconciliation.expectedClosingBalance) * 100
      : 0;
    reconciliation.notes = request.notes;
    reconciliation.updatedAtUtc = timestamp;

    const state = mockTillStates.find((t) => t.tillNumber === reconciliation.tillNumber);
    if (state) {
      state.status = 'Closed';
      state.currentBalance = 0;
      state.lastReconciliationId = reconciliation.id;
      state.lastReconciliationTimestamp = timestamp;
    }
    return reconciliation;
  }

  // Cash Drops
  async createCashDrop(request: CreateCashDropRequest): Promise<CashEventDto> {
    const timestamp = new Date().toISOString();
    const event: CashEventDto = {
      id: ++nextEventId,
      eventType: 'CashDrop',
      storeNumber: request.storeNumber,
      tillNumber: request.fromTillNumber,
      zoneId: request.toZoneId,
      amount: -Math.abs(request.amount),
      currencyCode: 'GBP',
      userId: 'user-1',
      username: 'Demo User',
      timestamp,
      referenceId: request.referenceId ?? `DROP-${nextEventId}`,
      isReversed: false,
      notes: request.notes,
      metadata: {},
      createdAtUtc: timestamp,
    };
    mockEvents.push(event);
    return event;
  }

  // Reconciliations
  async getCashReconciliations(storeNumber: string, startDate: string, endDate: string, status?: string): Promise<CashReconciliationDto[]> {
    // Demo data ignores store scoping entirely - return reconciliations regardless of store.
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    return mockReconciliations.filter((r) => {
      const t = new Date(r.reconciliationDate).getTime();
      const matchesStatus = !status || r.status === status;
      return matchesStatus && t >= start && t <= end;
    });
  }

  async getCashReconciliationById(reconciliationId: number): Promise<CashReconciliationDto> {
    const reconciliation = mockReconciliations.find((r) => r.id === reconciliationId);
    if (!reconciliation) throw new Error(`Reconciliation ${reconciliationId} not found`);
    return reconciliation;
  }

  async updateCashReconciliation(reconciliationId: number, updates: Partial<CashReconciliationDto>): Promise<CashReconciliationDto> {
    const reconciliation = mockReconciliations.find((r) => r.id === reconciliationId);
    if (!reconciliation) throw new Error(`Reconciliation ${reconciliationId} not found`);
    Object.assign(reconciliation, updates, { updatedAtUtc: new Date().toISOString() });
    return reconciliation;
  }

  async submitCashReconciliation(reconciliationId: number): Promise<CashReconciliationDto> {
    const reconciliation = mockReconciliations.find((r) => r.id === reconciliationId);
    if (!reconciliation) throw new Error(`Reconciliation ${reconciliationId} not found`);
    reconciliation.status = 'Submitted';
    reconciliation.updatedAtUtc = new Date().toISOString();
    return reconciliation;
  }

  async approveCashReconciliation(request: ApproveCashReconciliationRequest): Promise<CashReconciliationDto> {
    const reconciliation = mockReconciliations.find((r) => r.id === request.reconciliationId);
    if (!reconciliation) throw new Error(`Reconciliation ${request.reconciliationId} not found`);
    reconciliation.status = 'Reconciled';
    reconciliation.approvedByUserId = 'user-1';
    reconciliation.approvedByUsername = 'Demo User';
    reconciliation.approvedTimestamp = new Date().toISOString();
    reconciliation.notes = request.approvalNotes ?? reconciliation.notes;
    reconciliation.updatedAtUtc = new Date().toISOString();
    return reconciliation;
  }

  // Expected Cash Calculations
  async getExpectedCash(storeNumber: string, tillNumber: string, startDate: string, endDate: string): Promise<ExpectedCashCalculationDto> {
    return {
      storeNumber,
      tillNumber,
      startTimestamp: startDate,
      endTimestamp: endDate,
      openingBalance: 200,
      cashSales: 158.3,
      cardSales: 100,
      refunds: 0,
      paidIns: 0,
      paidOuts: 0,
      cashDrops: -100,
      expectedClosing: 258.3,
      transactionCount: 12,
    };
  }

  // Variance Investigation
  async startVarianceInvestigation(reconciliationId: number, notes: string): Promise<CashReconciliationDto> {
    const reconciliation = mockReconciliations.find((r) => r.id === reconciliationId);
    if (!reconciliation) throw new Error(`Reconciliation ${reconciliationId} not found`);
    reconciliation.status = 'VarianceUnderReview';
    reconciliation.investigationStatus = 'InProgress';
    reconciliation.investigationNotes = notes;
    reconciliation.updatedAtUtc = new Date().toISOString();
    return reconciliation;
  }

  async resolveVarianceInvestigation(reconciliationId: number, resolution: string): Promise<CashReconciliationDto> {
    const reconciliation = mockReconciliations.find((r) => r.id === reconciliationId);
    if (!reconciliation) throw new Error(`Reconciliation ${reconciliationId} not found`);
    reconciliation.status = 'Closed';
    reconciliation.investigationStatus = 'Resolved';
    reconciliation.investigationNotes = `${reconciliation.investigationNotes ?? ''}\nResolution: ${resolution}`.trim();
    reconciliation.updatedAtUtc = new Date().toISOString();
    return reconciliation;
  }
}
